<template>
  <div class="profile-page">
    <Button size="large" variation="primary" @onClick="logout">
      {{ $t("logout.button") }}
    </Button>
  </div>
</template>

<script lang="ts">
import Button from "@/design-system/elements/Button.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    Button,
  },
  methods: {
    logout() {
      this.$router.push({ path: "/logout" });
    },
  },
});
</script>

<style lang="scss">
.profile-page {
  padding-top: 15px;
  text-align: right;
}
</style>
